import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SwipeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"swipe"}/>
}
